module.exports = __webpack_public_path__ + "img/smile.13db2365.png";